

export default {
    //  自定义 拖动 指令 浏览器可视窗口中拖动

    // 本身 添加 v-drag
    //  需要子元素 class  win_head

    //         <div class="drag-box" v-drag>
    //             <div class="win_head">弹窗标题</div>
    //             <div class="win_content">弹窗内容</div>
    //         </div>


    components: {},
    props: {},
    data () {
        return {

            // 拖动事件 
            directives: {
                drag: {
                    // 指令的定义
                    bind: function (el, binding, vnode) {
                        // 获取到vue实例
                        let that = vnode.context;
                        let drag_dom = el;
                        // 获取到拖拽区
                        let drag_handle = el.querySelector(".win_head");
                        // 鼠标在拖拽区按下时触发拖拽
                        drag_handle.onmousedown = (e) => {
                            // 按下鼠标时，鼠标相对于被拖拽元素的坐标
                            let disX = e.clientX - drag_dom.offsetLeft;
                            let disY = e.clientY - drag_dom.offsetTop;

                            // 获取容器dom 浏览器可视窗口
                            // 获取视口的宽度
                            var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                            // 获取视口的高度
                            var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

                            document.onmousemove = (e) => {
                                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                                let left = e.clientX - disX;
                                let top = e.clientY - disY;

                                // 在容器范围内移动时，被拖拽元素的最大left值
                                let leftMax =
                                    0 +
                                    (viewportWidth - drag_dom.clientWidth - 10);

                                // 在容器范围内移动时，被拖拽元素的最小left值
                                let leftMin = 0 + 1; //此处+1为容器的边框1px

                                if (left > leftMax) {
                                    drag_dom.style.left = leftMax + "px";
                                } else if (left < leftMin) {
                                    drag_dom.style.left = leftMin + "px";
                                } else {
                                    drag_dom.style.left = left + "px";
                                }

                                // 在容器范围内移动时，被拖拽元素的最大top值
                                let topMax =
                                    0 +
                                    (viewportHeight - (drag_dom.clientHeight + 10));

                                // 在容器范围内移动时，被拖拽元素的最小top值
                                let topMin = 0 + 1; //此处+1为容器的边框1px

                                if (top > topMax) {
                                    drag_dom.style.top = topMax + "px";
                                } else if (top < topMin) {
                                    drag_dom.style.top = leftMin + "px";
                                } else {
                                    drag_dom.style.top = top + "px";
                                }
                            };

                            document.onmouseup = () => {
                                document.onmousemove = null;
                                document.onmouseup = null;
                            };
                        };
                    },
                },
            },

        };
    },
    computed: {},
    methods: {

        
        isIEFun () {
            var ua = window.navigator.userAgent;
            if (ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1) {
                // IE 10 or older
                this.isIE = true;
                return ;
            }
            this.isIE = false;
        },

        keyDown (e) {
            if (e.ctrlKey && e.keyCode == 13) {
                //用户点击了ctrl+enter触发  
                this.userInput += '\n';
                this.scrollToBottom();
            } else {
                //用户点击了enter触发  
                e.preventDefault();

                if(this.isCustomerInputting){
                    return;
                }
                
                this.sendMsg();
            }
        },


        // 输入框 定位到底部
        scrollToBottom () {
            const userInput = this.$refs.myTextarea;
            this.$nextTick(() => {
                if (userInput) {
                    userInput.scrollTop = userInput.scrollHeight;
                }
            });
        },

        // 更新 聊天框滚动 位置
        keepBootom () {
            this.$nextTick(() => {
                this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight + 200;
            });
        },


        // 显示缩短时间
        shortTime (t) {
            if (!t) {
                return;
            }
            let time = new Date(t);

            let today = new Date();
            let todayYear = today.getFullYear();
            let todayMonth = today.getMonth() + 1;
            let todayDate = today.getDate();

            let targetYear = time.getFullYear();
            let targetMonth = time.getMonth() + 1;
            let targetDate = time.getDate();
            let targetHour = time.getHours();
            let targetMinutes = time.getMinutes();
            let targetSeconds = time.getSeconds();


            // 同一天，只显示小时、分钟、秒
            if (todayYear === targetYear && todayMonth === targetMonth && todayDate === targetDate) {
                if (targetHour < 10) {
                    targetHour = "0" + targetHour;
                }
                if (targetMinutes < 10) {
                    targetMinutes = "0" + targetMinutes;
                }
                if (targetSeconds < 10) {
                    targetSeconds = "0" + targetSeconds;
                }
                return targetHour + ":" + targetMinutes + ":" + targetSeconds;
            }
            // 同一年，只显示月日等
            if (todayYear === targetYear) {

                if (targetMonth < 10) {
                    targetMonth = "0" + targetMonth;
                }
                if (targetDate < 10) {
                    targetDate = "0" + targetDate;
                }
                if (targetHour < 10) {
                    targetHour = "0" + targetHour;
                }
                if (targetMinutes < 10) {
                    targetMinutes = "0" + targetMinutes;
                }
                if (targetSeconds < 10) {
                    targetSeconds = "0" + targetSeconds;
                }
                return `${targetMonth}-${targetDate} ` + targetHour + ":" + targetMinutes + ":" + targetSeconds;
            }
            return t;
        },

        objectToQueryString (obj) {
            return Object.keys(obj)
                .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
                .join('&');
        },


    },
};